import React from 'react';
import ReactDOM from 'react-dom';
import './style/reset.css'
import './style/style.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));